import { Rating } from "react-simple-star-rating";
import { Col, Row } from "reactstrap";
import { RateNow } from "../../../../../constants";

// A component that displays the star rating for the product review.
const Review = () => {
  return (
    <Row>
      <Col md="4">
        <h4>{RateNow}</h4>
      </Col>
      <Col md="8">
        <div className="d-flex">
          <div className="rating">
            <Rating initialValue={3} size={17} />
          </div>
          <span className="ms-2">(250 review)</span>
        </div>
      </Col>
    </Row>
  );
};
export default Review;